import React, { Fragment } from 'react';
import { Button, Form, Grid, Header, Icon, Label, Loader, Popup, Segment, Table, TableCell } from 'semantic-ui-react';
import axios from 'axios';
import moment, { now } from 'moment';
import { toast } from 'react-toastify';
import { IconHeader } from '../../../Professor/ProfessorInputGrades/css';
import DateTimePicker from 'react-widgets/lib/DateTimePicker';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;


export default class Positions extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

            orgUnitPositions: [],
            position: null,
            dateStart: null,
            dateEnd: null,

            loading: true,

            data: [],
            addNewPosition: false,
            positionErr: false,
            editMode: false,
            id: null,
            optLock: null,
            main: null,

            positionName: null
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.getOrgUnitPositions = this.getOrgUnitPositions.bind(this);
        this.getPositions = this.getPositions.bind(this);
        this.addNewPosition = this.addNewPosition.bind(this);
        this.deletePosition = this.deletePosition.bind(this);
        this.edit = this.edit.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
    }

    componentDidMount() {
        const { employment } = this.props;
        this.getPositions(employment.id);
        this.getOrgUnitPositions(employment.organizationalUnit.id);

        this.setState({
            main: localStorage.getItem('main') === 'true'
        });
    }

    getPositions(orgUnitEmployeeId) {
        let obj = { id: orgUnitEmployeeId };
        axios.post('employees/oue-positions', { ...obj })
            .then(res => {
                this.setState({
                    data: res.data, loading: false
                });
            })
            .catch(err => {
                console.log('Failed to fetch positions.');
            });
    }

    getOrgUnitPositions(orgUnitId) {
        let obj = { id: orgUnitId };
        axios.post('hr/positions-by-organizational-unit/', { ...obj })
            .then(res => {
                this.setState({
                    orgUnitPositions: res.data.map(el => ({
                        ...el,
                        value: el.id,
                        key: el.id,
                        text: el.name
                    }))
                });
            })
            .catch(err => {
                console.log('Failed to fetch positions.');
            });
    }

    addNewPosition() {
        if (!this.state.position) {
            toast('Morate unijeti poziciju.');
        } else {
            // var myToday = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0);
            let obj = {
                organizationalUnitEmployeeId: this.props.employment.id,
                positionId: this.state.position,
                description: this.state.description,
                dateEnd: this.state.dateEnd ? new Date(new Date(this.state.dateEnd).getFullYear(), new Date(this.state.dateEnd).getMonth(), new Date(this.state.dateEnd).getDate(), 0, 0, 0, 0) : null,
                dateStart: this.state.dateStart ? new Date(new Date(this.state.dateStart).getFullYear(), new Date(this.state.dateStart).getMonth(), new Date(this.state.dateStart).getDate(), 0, 0, 0, 0) : null,
            };

            axios.post('employees/add-position', { ...obj })
                .then(res => {
                    toast('Uspješno ste dodali novu poziciju.');
                    this.getPositions(this.props.employment.id);
                    this.setState({
                        addNewPosition: false,
                        position: null,
                        dateStart: null,
                        dateEnd: null,
                        loading: true
                    });
                })
                .catch(err => {
                    if (err.response.data === 'startDate must be before endDate!') {
                        toast('Datum početka mora biti ispred datuma kraja.');
                    } else if (err.response.data === 'ouep dateStart must be after oue dateStart.') {
                        toast('Datum početka ne smije biti prije datuma početka angažmana.');
                    } else if (err.response.data === 'ouep dateEnd must be before oue dateEnd.') {
                        toast('Datum kraja mora biti prije datuma kraja angažmana.');
                    } else if (err.response.data === 'OUEP already exists!') {
                        toast('Ta pozicija je već dodata.');
                    } else {
                        toast('Došlo je do greške. Dodavanje pozicije nije uspjelo.');
                    }
                });
        }
    }

    edit() {
        let obj = {
            organizationalUnitEmployeeId: this.props.employment.id,
            description: this.state.description,
            optLock: this.state.optLock,
            id: this.state.id,
            dateEnd: this.state.dateEnd ? new Date(new Date(this.state.dateEnd).getFullYear(), new Date(this.state.dateEnd).getMonth(), new Date(this.state.dateEnd).getDate(), 0, 0, 0, 0) : null,
            dateStart: this.state.dateStart ? new Date(new Date(this.state.dateStart).getFullYear(), new Date(this.state.dateStart).getMonth(), new Date(this.state.dateStart).getDate(), 0, 0, 0, 0) : null,
        };

        axios.put('employees/update-position', { ...obj })
            .then(res => {
                toast('Uspješno ste izmijenili poziciju.');
                this.setState({
                    index: null,
                    editMode: false,
                    loading: true,
                    optLock: null,
                    id: null,
                    dateEnd: null,
                    dateStart: null
                });
                this.getPositions(this.props.employment.id);
            })
            .catch(err => {
                if (err.response.data === 'startDate must be before endDate!') {
                    toast('Datum početka mora biti ispred datuma kraja.');
                } else if (err.response.data === 'ouep dateStart must be after oue dateStart.') {
                    toast('Datum početka ne smije biti prije datuma početka angažmana.');
                } else if (err.response.data === 'ouep dateEnd must be before oue dateEnd.') {
                    toast('Datum kraja mora biti poslije datuma kraja angažmana.');
                } else {
                    toast('Došlo je do greške. Izmjena pozicije nije uspjela.');
                }
            });
    }

    deletePosition(id) {
        this.setState({ loading: true });
        let obj = { id };
        axios.delete('employees/delete-position', { data: obj })
            .then(res => {
                toast('Uspješno ste obrisali poziciju.');
                this.getPositions(this.props.employment.id);
            })
            .catch(err => {
                toast('Došlo je do greške. Brisanje pozicije nije uspjelo.');
            });
    }


    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value
        });
    }

    handleDateChange(name, date) {
        this.setState({
            [name]: date
        });
    }


    render() {
        const { employment } = this.props;
        return (
            <div>

                <Segment.Group>
                    <Segment secondary>

                        <Header as="h4">
                            <Header style={IconHeader} floated="right" >
                                <Icon />
                                <Popup
                                    trigger={<Icon link circular basic="true" floated="right" name="close" onClick={this.props.close} />}
                                    content="Zatvori"
                                    hideOnScroll
                                    position="top center"
                                />
                            </Header>
                            <span style={{ color: 'black' }}>{employment ? employment.organizationalUnit.name : ''} - radne pozicije</span>

                        </Header>
                    </Segment>
                    <Segment>

                        <Table celled selectable size="small">
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell>Naziv pozicije</Table.HeaderCell>
                                    <Table.HeaderCell>Na poziciji od:</Table.HeaderCell>
                                    <Table.HeaderCell>Na poziciji do:</Table.HeaderCell>
                                    {(this.state.main || localStorage.getItem('associate') === 'true' && localStorage.getItem('activeRole').substr(0, 9) !== 'HR admin:') &&
                                    <Table.HeaderCell as="th" verticalAlign="middle" textAlign="center">
                                        <Popup
                                            content="Dodaj poziciju"
                                            position="top center"
                                            trigger={
                                                <Button
                                                    icon="add"
                                                    size="small"
                                                    basic="true"
                                                    color="blue"
                                                    circular
                                                    compact
                                                    onClick={() => this.setState({ addNewPosition: true })}
                                                />}
                                        />
                                    </Table.HeaderCell>}
                                </Table.Row>
                            </Table.Header>
                            { this.state.loading ? <div><br /><Loader active inline="centered" /><br /></div> :
                                (this.state.data.length || this.state.addNewPosition) ? <Table.Body>
                                    {(this.state.addNewPosition || this.state.editMode) && <Table.Row>
                                        <Table.Cell>
                                            {this.state.addNewPosition ? <Form noValidate>
                                                <Form.Field required error={this.state.positionErr}>
                                                    <Form.Dropdown
                                                        selection
                                                        placeholder="Odaberite poziciju"
                                                        value={this.state.position}
                                                        onChange={this.handleInputChange}
                                                        name="position"
                                                        options={this.state.orgUnitPositions}
                                                        search
                                                        fluid
                                                    />
                                                </Form.Field>
                                            </Form> : this.state.positionName}
                                        </Table.Cell>
                                        <TableCell textAlign="center" verticalAlign="middle">
                                            <Form>
                                                <Form.Field>
                                                    <DateTimePicker
                                                        format="D. M. YYYY."
                                                        time={false}
                                                        onChange={this.handleDateChange.bind(null, 'dateStart')}
                                                        value={this.state.dateStart ? new Date(this.state.dateStart) : this.state.dateStart}
                                                    />
                                                </Form.Field>
                                            </Form>
                                        </TableCell>
                                        <TableCell textAlign="center" verticalAlign="middle">
                                            <Form>
                                                <Form.Field>
                                                    <DateTimePicker
                                                        format="D. M. YYYY."
                                                        time={false}
                                                        onChange={this.handleDateChange.bind(null, 'dateEnd')}
                                                        value={this.state.dateEnd ? new Date(this.state.dateEnd) : this.state.dateEnd}
                                                    />
                                                </Form.Field>
                                            </Form>
                                        </TableCell>
                                        <Table.Cell textAlign="center" verticalAlign="middle" >
                                            <Button color="blue" circular compact icon="check" onClick={this.state.editMode ? this.edit : this.addNewPosition} />
                                            <Button
                                                color="blue"
                                                basic="true"
                                                circular
                                                compact
                                                icon="close"
                                                onClick={() => this.setState({
                                                    index: null, position: null, positionErr: false, editMode: false, addNewPosition: false, dateEnd: null, dateStart: null
                                                })}
                                            />
                                        </Table.Cell>
                                    </Table.Row>}
                                    {this.state.data.map((el, index) =>
                                        (this.state.index !== index && <Table.Row key={index}>
                                            <Table.Cell verticalAlign="middle">
                                                {el.position.name}
                                            </Table.Cell>
                                            <Table.Cell verticalAlign="middle">
                                                { el.dateStart && moment(el.dateStart).format('D. M. YYYY.')}
                                            </Table.Cell>
                                            <Table.Cell verticalAlign="middle">
                                                {el.dateEnd && moment(el.dateEnd).format('D. M. YYYY.')}
                                                <span style={{ float: 'right' }}> {moment(el.dateEnd) <= moment(now()) && <Label prompt size="mini" color="red" basic> <Icon name="attention" /> Isteklo</Label>}</span>
                                            </Table.Cell>
                                            {(this.state.main || localStorage.getItem('associate') === 'true' && localStorage.getItem('activeRole').substr(0, 9) !== 'HR admin:') && <Table.Cell verticalAlign="middle" textAlign="center">
                                                <Button
                                                    basic="true"
                                                    color="green"
                                                    circular
                                                    compact
                                                    icon="pencil"
                                                    size="small"


                                                    onClick={() => {
                                                        this.setState({
                                                            index,
                                                            editMode: true,
                                                            description: el.description,
                                                            optLock: el.optLock,
                                                            id: el.id,
                                                            position: el.position.id,
                                                            dateEnd: el.dateEnd,
                                                            dateStart: el.dateStart,
                                                            positionName: el.position.name
                                                        });
                                                    }}
                                                />
                                                <Button
                                                    color="red"
                                                    basic="true"
                                                    size="small"
                                                    circular
                                                    compact
                                                    icon="trash alternate"
                                                    onClick={() => this.deletePosition(el.id)}
                                                />
                                            </Table.Cell>}
                                        </Table.Row>
                                        ))}
                                </Table.Body> :
                                <Table.Body>
                                        <Table.Row>
                                        <Table.Cell
                                                colSpan={this.state.main || localStorage.getItem('associate') === 'true' && localStorage.getItem('activeRole').substr(0, 9) !== 'HR admin:' ? '2' : '1'}
                                            >
                                                Nema dodanih pozicija za ovu organizacionu jedinicu.
                                            </Table.Cell>
                                    </Table.Row>
                                    </Table.Body>}

                        </Table>
                    </Segment>
                </Segment.Group>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/HR/profile/Employee/Positions.js